import { render, staticRenderFns } from "./ContentPanel.vue?vue&type=template&id=50256484&scoped=true&"
import script from "./ContentPanel.vue?vue&type=script&lang=js&"
export * from "./ContentPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContentPanel.vue?vue&type=style&index=0&id=50256484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50256484",
  null
  
)

export default component.exports